import { SubcategoryProcessingRule } from './interfaces';
import { subcategoryHasProductsRule } from './rules/subcategory-has-products.rule';
import { subcategoryIsAvailableRule } from './rules/subcategory-is-available.rule';
import { availabilityOutsideCurrentScheduleRule } from '@core/domain/availability';

export class SubcategoryFactory {
	createHomeRules(): SubcategoryProcessingRule[] {
		return [
			availabilityOutsideCurrentScheduleRule,
			subcategoryHasProductsRule,
			subcategoryIsAvailableRule,
		];
	}
}
